import { Stack } from '@eneco/sparky';
import { Placeholder } from '@sitecore/common';

export const ButtonLineUp = () => {
  return (
    <Stack direction={{ initial: 'column', md: 'row' }} gap="5" wrap>
      <Placeholder name="jss-buttons" />
    </Stack>
  );
};

export default ButtonLineUp;
